import React, { useEffect, useRef, useState } from "react";

const IPAD_PORTRAIT_WIDTH = 820;
const IPAD_PORTRAIT_HEIGHT = 1180;
const PREVIEW_MAX_HEIGHT = 500;

const EventWebappPreview = ({ src, title }) => {
  const [containerWidth, setContainerWidth] = useState(0);
  const [isMobileViewport, setIsMobileViewport] = useState(
    () => typeof window !== "undefined" && window.innerWidth < 768,
  );
  const [viewportHeight, setViewportHeight] = useState(
    () => typeof window !== "undefined" ? window.innerHeight : IPAD_PORTRAIT_HEIGHT,
  );
  const containerRef = useRef(null);
  const fallbackContainerWidth = typeof window !== "undefined"
    ? Math.max(0, Math.min(Math.min(window.innerWidth * 0.76, 1180) - 40, 1140))
    : IPAD_PORTRAIT_WIDTH;
  const availableHeight = typeof window !== "undefined"
    ? Math.max(viewportHeight - 140, 1)
    : IPAD_PORTRAIT_HEIGHT;
  const fittedHeight = Math.min(PREVIEW_MAX_HEIGHT, availableHeight);
  const previewWidth = Math.min(
    containerWidth || fallbackContainerWidth,
    IPAD_PORTRAIT_WIDTH,
    IPAD_PORTRAIT_WIDTH * fittedHeight / IPAD_PORTRAIT_HEIGHT,
  );
  const scale = previewWidth / IPAD_PORTRAIT_WIDTH;

  useEffect(() => {
    const updateViewport = () => {
      setIsMobileViewport(window.innerWidth < 768);
      setViewportHeight(window.innerHeight);
    };
    window.addEventListener("resize", updateViewport);
    return () => window.removeEventListener("resize", updateViewport);
  }, []);

  useEffect(() => {
    if (isMobileViewport) return undefined;

    const container = containerRef.current;
    if (!container) return undefined;

    const updateContainerSize = () => setContainerWidth(container.clientWidth);
    updateContainerSize();

    const observer = typeof ResizeObserver === "function"
      ? new ResizeObserver(updateContainerSize)
      : null;
    observer?.observe(container);
    window.addEventListener("resize", updateContainerSize);

    return () => {
      observer?.disconnect();
      window.removeEventListener("resize", updateContainerSize);
    };
  }, [isMobileViewport]);

  if (!src) return null;

  return (
    <div
      className="event-webapp-preview-container"
      ref={containerRef}
      style={isMobileViewport ? undefined : { width: previewWidth, flex: "0 0 auto" }}
    >
      <div
        className={"event-webapp-preview-stage " + (isMobileViewport ? "is-mobile" : "is-desktop")}
        style={isMobileViewport ? undefined : {
          width: previewWidth,
          aspectRatio: IPAD_PORTRAIT_WIDTH + " / " + IPAD_PORTRAIT_HEIGHT,
        }}
      >
        <iframe
          className={"event-webapp-preview-frame " + (isMobileViewport ? "is-mobile" : "is-desktop")}
          src={src}
          title={title}
          loading="lazy"
          allowFullScreen
          style={isMobileViewport ? undefined : {
            width: IPAD_PORTRAIT_WIDTH,
            height: IPAD_PORTRAIT_HEIGHT,
            transform: "scale(" + scale + ")",
            transformOrigin: "top left",
          }}
        />
      </div>
    </div>
  );
};

export default EventWebappPreview;
